import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconToolsHoldStartSizeS from './IconToolsHoldStart_size_s';

const props: CreateIconArguments = {
  l: IconToolsHoldStartSizeS,
  m: IconToolsHoldStartSizeS,
  s: IconToolsHoldStartSizeS,
  xs: IconToolsHoldStartSizeS,
  name: 'IconToolsHoldStart',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
